import styled from 'styled-components';

import { StaticContentSection } from '@/components/Base/StaticContent/StaticContent.styles';
import {
  colorBlack900,
  colorBorder,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryTabletSmallMin,
} from '@/styleUtils';

export const Wrapper = styled(StaticContentSection)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Blocks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${mediaQueryTabletSmallMin} {
    flex-direction: row;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style-type: none;
  padding: 0;
`;
export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font: 400 14px/20px ${fontFamilyPrimary};
  color: ${colorBlack900};
`;

export const StyledImg = styled.img`
  width: 56px;
  height: 56px;
`;
export const SectionTitle = styled.h3`
  font: 700 18px/24px ${fontFamilySecondary};
  color: ${colorBlack900};
`;

export const BlockWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  box-shadow:
    -1px 0 0 0 ${colorBorder} inset,
    1px 0 0 0 ${colorBorder} inset,
    0 -1px 0 0 ${colorBorder} inset,
    0 1px 0 0 ${colorBorder} inset;
`;
